export default __webpack_public_path__ + "static/media/level-icon.bafca75d.svg";